import { EPaidProductType } from '../type'

import type { EProductType } from '../type'

export const isUnlimited = (productType?: EPaidProductType | EProductType) => {
  return productType === EPaidProductType.UNLIMITED
}
